import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, Plus } from 'lucide-react';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const navigate = useNavigate();

  return (
    <div className="prod-card bg-white rounded-xl overflow-hidden border border-gray-100 shadow-sm flex flex-col">
      <div
        className="relative overflow-hidden cursor-pointer aspect-square bg-gray-50"
        onClick={() => navigate(`/product/${product.id}`)}
      >
        <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" />
        {product.isNew && (
          <span className="absolute top-3 left-3 ps-yellow-bg text-black text-xs font-bold px-2.5 py-1 rounded-full font-oswald uppercase tracking-wide shadow">New</span>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-0.5 mb-1.5">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={13} className={i < product.rating ? 'fill-[#ffd400] text-[#ffd400]' : 'text-gray-300'} />
          ))}
        </div>
        <h3
          className="font-oswald text-lg text-gray-900 leading-tight cursor-pointer hover:text-[#1a1ad6] transition-colors"
          onClick={() => navigate(`/product/${product.id}`)}
        >
          {product.name}
        </h3>
        <p className="text-sm text-gray-500 mt-1 line-clamp-2 flex-1">{product.desc}</p>
        <div className="mt-4">
          <button
            onClick={() => addItem(product)}
            className="btn-press w-full ps-blue-bg text-white text-sm font-oswald uppercase tracking-wide px-4 py-2.5 rounded-lg flex items-center justify-center gap-1.5 hover:bg-[#0f0fa0]"
          >
            <Plus size={16} /> Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
